import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ChartTooltip,
  Legend
);

// Chart.js-based grouped bar chart
// Data: [{ label: 'Mon', current: 40, previous: 28 }, ...]
const SalesOverview = ({ data }) => {
  const rawData = useMemo(
    () =>
      data && data.length
        ? data
        : [
            { label: 'Mon', current: 40, previous: 28 },
            { label: 'Tue', current: 24, previous: 27 },
            { label: 'Wed', current: 30, previous: 26 },
            { label: 'Thu', current: 42, previous: 31 },
            { label: 'Fri', current: 26, previous: 19 },
            { label: 'Sat', current: 33, previous: 22 },
            { label: 'Sun', current: 30, previous: 24 },
          ],
    [data]
  );

  const chartData = {
    labels: rawData.map((item) => item.label),
    datasets: [
      {
        label: 'Previous',
        data: rawData.map((item) => item.previous),
        backgroundColor: '#D1D5DB',
        borderRadius: 6,
        borderSkipped: false,
      },
      {
        label: 'Current',
        data: rawData.map((item) => item.current),
        backgroundColor: '#0B0A17',
        borderRadius: 6,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide legend to match design
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: 'white',
        bodyColor: 'white',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        borderWidth: 1,
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: $${context.parsed.y}K`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#9CA3AF',
          font: {
            size: 12,
          },
        },
        border: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        max: 40,
        ticks: {
          stepSize: 10,
          color: '#9CA3AF',
          font: {
            size: 12,
          },
          callback: function (value) {
            return `$${value}K`;
          },
        },
        grid: {
          color: '#D1D5DB',
          drawBorder: false,
          drawTicks: false,
        },
        border: {
          display: false,
        },
      },
    },
    interaction: {
      intersect: false,
    },
  };

  return (
    <div
      className="bg-white rounded-[16px] p-4 sm:p-7"
      style={{ boxShadow: '0px 4px 16px 0px #0000001A' }}
    >
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
        <div>
          <h2 className="text-[#000000] text-[18px] sm:text-[20px] lg:text-[24px] leading-[27px] sm:leading-[30px] lg:leading-[36px] font-bold tracking-[-0.50px] poppins">
            Sales Overview
          </h2>
          <p className="text-[#B9BCC6] text-[14px] sm:text-[16px] leading-[20px] sm:leading-[24px] tracking-[-0.64px] poppins font-normal">
            Your sales statistic report
          </p>
        </div>
        <button className="text-[#0B0A17] text-[12px] sm:text-[14px] font-medium self-start sm:self-auto">
          View Details
        </button>
      </div>

      <div
        className="mt-4 sm:mt-2"
        style={{ height: window.innerWidth < 640 ? 250 : 360 }}
      >
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default SalesOverview;
